var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubjectInput = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.73047V13.3925C12.0006 13.48 11.984 13.5668 11.951 13.6479C11.9181 13.7291 11.8695 13.8029 11.808 13.8652C11.7466 13.9276 11.6734 13.9772 11.5928 14.0113C11.5121 14.0453 11.4255 14.0632 11.338 14.0638H0.662C0.486542 14.0638 0.318261 13.9941 0.194131 13.8701C0.070001 13.7461 0.000176695 13.5779 0 13.4025V1.3918C0 1.0338 0.299333 0.730469 0.668 0.730469H7.998L12 4.73047ZM10.6667 5.39714H7.33333V2.0638H1.33333V12.7305H10.6667V5.39714ZM3.33333 4.0638H5.33333V5.39714H3.33333V4.0638ZM3.33333 6.73047H8.66667V8.0638H3.33333V6.73047ZM3.33333 9.39713H8.66667V10.7305H3.33333V9.39713Z",
    fill: "#AAAAAA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubjectInput);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subject-input.89d7410da4ffa4149c9f9cb990b1e6ee.svg";